module.exports = __webpack_public_path__ + "img/nfse.22f66914.png";